import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/assets/icons/social-whatsapp.svg")